<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar color="primary" dark>
            <v-toolbar-title>Change Log</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Date</th>
                    <th class="text-left">Author</th>
                    <th class="text-left">Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in changeLog" :key="item.id">
                    <td>{{ item.date }}</td>
                    <td>{{ item.author }}</td>
                    <td>{{ item.subject }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
export default {
  name: "ChangeLog",
  data() {
    return {
      changeLog: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      axios.get("/api/v1/updates/commits").then((response) => {
        that.changeLog = response.data;
      });
    },
  },
};
</script>
